<template>
  <section v-if="listNotification.length" class="section--pd Imp__con">
    <div class="inner">
      <div class="Imp__inner">
        <h2 class="Head__info">
          大切なお知らせ
        </h2>
        <div class="Info__inner">
          <div
            v-for="( item,key ) of listNotification"
            :key="key"
            class="Info__line"
          >
            <a
              :key="key"
              class="Info__link"
              @click="readNoti(item.info)"
            >
              <span
                :class="!item.read ? 'Info__link--new' : ''"
              >
                {{ item.info.title }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import notificationService from '@/services/notificationService'

export default {
  data() {
    return {
      listNotification: [],
      newInfo: 0
    }
  },
  created() {
    this.getListNotification()
  },
  methods: {
    async getListNotification() {
      this.$emit('updateNotification', true)
      const response = await notificationService.list()
      const result = []
      const result_error = []
      await response.data.forEach(element => {
        if (element.info.noti_flag === 1 && element.status_read === 0) {
          result.push(element)
          if (element.info.error_status === 1 || element.info.error_status === 2) {
            result_error.push(element)
          }
        }
      })
      const array_concat = result_error.concat(result)
      const show_noti = [...new Set(array_concat)]
      this.listNotification = show_noti.slice(0, 5)
      this.$emit('updateNotification', false)
    },
    async readNoti(info) {
      if (info.error_status !== 1 && info.error_status !== 2) {
        await notificationService.read(info.id)
      }
      window.location.href = info.link
    }
  }
}
</script>
